import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../Home.vue'
import store from '../store/index'
import PagesRoutes from './PagesRoutes'
import NewsRoutes from './NewsRoutes'
import ReportsRoutes from './ReportsRoutes'
import ImagesRoutes from './ImagesRoutes'
import ContactsRoutes from './ContactsRoutes'
import LivetRoutes from './LivetRoutes'
import UsersRoutes from './UsersRoutes'
import SettingsRoutes from './SettingsRoutes'
import SearchLogsRoutes from './SearchLogsRoutes'

Vue.use(VueRouter)

const requireAuth = (to, from, next) => {
  if (store.getters['auth/isSignedIn']) {
    next()
    return
  }
  next('/signin')
}
// const isAuthorized = (to, from, next) => {
//   if (store.getters['auth/isSignedIn']) {
//     next({ name: 'Home' })
//     return
//   }
//   next('/signin')
// }

const routes = [
  {
    path: '',
    component: Home,
    beforeEnter: requireAuth,
    children: [
      {
        path: '/',
        name: 'Start',
        component: () => import(/* webpackChunkName: "Start" */ '../views/start/Start.vue'),
      },
      PagesRoutes,
      NewsRoutes,
      ReportsRoutes,
      ImagesRoutes,
      ContactsRoutes,
      UsersRoutes,
      SettingsRoutes,
      SearchLogsRoutes,
      ...LivetRoutes,
    ],
  },
  {
    path: '/signin',
    name: 'SignIn',
    component: () => import(/* webpackChunkName: "SignIn" */ '../views/signin/SignIn.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  },
})

export default router
